define('boxes/helpers/middle-bar-helper',[], function () {
    'use strict';

    function findMiddleBar(boxInstance, middleBarClass) {
        var $slidingContentWrapperDiv = boxInstance.$controller.$controller.closest('div').parent(),
            $middleBar = $slidingContentWrapperDiv.find('.middle.bar.' + middleBarClass);

        if ($middleBar.length > 0) {
            return $middleBar;
        }
        return $slidingContentWrapperDiv.parent().find('.middle.bar.' + middleBarClass);
    }

    return {
        show: function(boxInstance, middleBarClass) {
            var $middleBarElement = findMiddleBar(boxInstance, middleBarClass);
            $middleBarElement.show();
        },
        hide: function(boxInstance, middleBarClass) {
            var $middleBarElement = findMiddleBar(boxInstance, middleBarClass);
            $middleBarElement.hide();
        },
        findMiddleBar: findMiddleBar
    };
});

